import React, { useState, useEffect } from 'react';

const MeetLex = () => {
  const [displayText, setDisplayText] = useState('');
  const [isTypingComplete, setIsTypingComplete] = useState(false);
  const fullText = 'Meet';

  useEffect(() => {
    let currentIndex = 0;
    
    const typingInterval = setInterval(() => {
      if (currentIndex < fullText.length) {
        setDisplayText(fullText.slice(0, currentIndex + 1));
        currentIndex++;
      } else {
        clearInterval(typingInterval);
        setIsTypingComplete(true);
      }
    }, 80);

    return () => clearInterval(typingInterval);
  }, []);

  return (
    <div className="flex items-center text-4xl font-bold">
      <span><b>{displayText}</b></span>
      
      {!isTypingComplete && (
        <span className="animate-pulse ml-0.5 w-0.5 h-8 bg-black" />
      )}
      
      {isTypingComplete && (
        <>
        {" "}
          <b>
          <span 
            className="inline-block lex-color"
            style={{
              color: "rgb(139, 57, 151)",
              animation: 'zoom 0.5s ease-out forwards',
              transformOrigin: 'left center'
            }}
          >
            Lex.
          </span>
          </b>
        </>
      )}
      
      <style jsx>{`
        @keyframes zoom {
          0% {
            transform: scale(1.5);
            opacity: 0;
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default MeetLex;